import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-white" data-id="element-130" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-131" data-mp="3o77mq6778ekx">
        <SectionHeader id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para organizar tus clases de Electromecánica." data-id="element-132" data-mp="3j9fsv6mzuie3" />
        <p className="mt-1.5 text-center font-condensed text-sm font-bold text-tech sm:text-base" data-id="element-133" data-mp="3t6aqlnbg0erb">⚙️ {PRODUCT_NAME}</p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[0.82rem] leading-snug text-navy/75 sm:text-sm" data-id="element-134" data-mp="5vb2ih2dawet">
          No es simplemente otro ebook técnico. Es una biblioteca educativa organizada para ayudarte a enseñar qué
          viene primero, qué contenido continúa después y cómo conectar teoría, prácticas, automatismos, mantenimiento
          y proyectos.
        </p>

        <ol className="mt-2.5 grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-135" data-mp="36cp1irju1tip">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-2.5" data-id="element-136" data-mp="3bbjsigryeodw" data-mpi={i}>
              <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-navy pt-0.5 font-bebas text-3xl leading-none text-volt" data-id="element-137" data-mp="3kadllx62swmp">
                {i + 1}
              </span>
              <div data-id="element-138" data-mp="3u8kya3tc0siw">
                <p className="font-bebas text-sm leading-none tracking-wide text-alert" data-id="element-139" data-mp="3u81eehk4fu28">Tomo {i + 1}</p>
                <h3 className="font-condensed text-sm font-bold leading-tight text-navy sm:text-base" data-id="element-140" data-mp="2tnbgnyug1dv">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.78rem] leading-snug text-navy/75 sm:text-sm" data-id="element-141" data-mp="6u79dtr8r912">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-142" data-mp="gteuj347w7yq" />
      </div>
    </section>;
}